var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
class HTMLText extends Component {
    render() {
        // eslint-disable-next-line prefer-const
        let _a = this.props, { text, html, component } = _a, props = __rest(_a, ["text", "html", "component"]);
        if (text) {
            html = text.replace(/(?:\r)?\n/g, '<br/>');
        }
        if (html) {
            return React.createElement(component, Object.assign(Object.assign({}, props), { onClick: this._handleClick.bind(this), dangerouslySetInnerHTML: { __html: html } }));
        }
        else {
            return null;
        }
    }
    _handleClick(event) {
        if (event.target.nodeName === 'A') {
            const href = event.target.getAttribute('href');
            const target = event.target.getAttribute('target');
            if (!target && (/^\/[^\/]/.test(href) || href === '/')) {
                event.preventDefault();
                event.stopPropagation();
                this.context.history.push(href);
            }
        }
    }
}
HTMLText.contextTypes = {
    history: PropTypes.object,
};
HTMLText.propTypes = {
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};
HTMLText.defaultProps = {
    component: 'span',
};
export default HTMLText;
